const BreadCrumbConstant = {
  login: 'Login',
  signUp: 'Sign Up'
};

export { BreadCrumbConstant };
